<header>
  <div class="separator mb-auto"></div>
</header>
